module.exports = __webpack_public_path__ + "static/tessa-f8af501cf9871d7fc5f0e4f3331cc200.gif";